import React from 'react';
import { cn } from '../../utils/cn';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, id, name, label, error, hint, rows = 3, ...props }, ref) => {
    const reactId = React.useId();
    const textareaId = id ?? name ?? reactId;

    return (
      <div className="space-y-1.5">
        {label ? (
          <label htmlFor={textareaId} className="block text-sm font-medium text-ink-700">
            {label}
          </label>
        ) : null}
        <textarea
          ref={ref}
          id={textareaId}
          name={name}
          rows={rows}
          className={cn(
            'block w-full resize-y rounded-lg border bg-white px-3 py-2 text-sm text-ink-900 transition-colors duration-200 placeholder:text-ink-400 focus:outline-none focus:ring-2 disabled:cursor-not-allowed disabled:bg-ink-50 disabled:text-ink-500',
            error
              ? 'border-danger-100 focus:border-danger-600 focus:ring-danger-100'
              : 'border-ink-300 focus:border-academy-500 focus:ring-academy-100',
            className,
          )}
          {...props}
        />
        {error ? (
          <p className="text-sm text-danger-600">{error}</p>
        ) : hint ? (
          <p className="text-sm text-ink-500">{hint}</p>
        ) : null}
      </div>
    );
  },
);

Textarea.displayName = 'Textarea';
